import log from "loglevel";
import {PubSub} from "./pub-sub";
import {Utils} from "./utils";

// The namespace of the compiles templates. The code that creates these
// is auto-generated so we cannot set the global variable there.
window.views = {};

// Expose log everywhere so that it does not need importing in every class
// that potentially uses it.
window.log = log;
window.imageFilenameLookup = window.imageFilenameLookup || {};
window.pubsub = new PubSub();

window.utils = Utils;

// For Facebook: will be initialized after script loads
window.FB = window.FB || null;
window.LineIt = window.LineIt || null;
window.google = window.google || null;

window.mapsApiReady = () => {
    pubsub.publish("maps-api-ready");
};
